/** Si todos los `ts` visibles superan esto, conviene un fetchDrivers completo (no solo tick). */
export const MAP_DRIVER_STALE_UI_MS = 90 * 1000;

export const mergeDriverLocationUpdates = (drivers, updatesByUid) => {
  if (!Array.isArray(drivers) || !drivers.length || !updatesByUid) {
    return { next: drivers, changed: false, readCount: 0 };
  }
  let changed = false;
  const next = drivers.map((d) => {
    const uid = d.uid || d.id;
    const loc = uid ? updatesByUid[uid] : null;
    if (!loc) return d;
    const prev = d.location || {};
    const same = Number(prev.lat) === Number(loc.lat)
      && Number(prev.lng) === Number(loc.lng)
      && Number(prev.ts) === Number(loc.ts);
    if (same) return d;
    changed = true;
    return { ...d, location: { ...prev, ...loc } };
  });
  return { next, changed, readCount: Object.keys(updatesByUid).length };
};

/** true si hay conductores pero ninguno tiene ubicación fresca para el mapa de inicio */
export const driversNeedFullRefresh = (drivers, now = Date.now()) => {
  if (!Array.isArray(drivers) || drivers.length === 0) return false;
  let withLoc = 0;
  let fresh = 0;
  for (let i = 0; i < drivers.length; i++) {
    const loc = drivers[i]?.location;
    if (loc?.lat == null || loc?.lng == null) continue;
    withLoc++;
    const ts = Number(loc.ts);
    if (!(ts > 0) || now - ts <= MAP_DRIVER_STALE_UI_MS) fresh++;
  }
  return withLoc > 0 && fresh === 0;
};
